import { CargaDescargaState, CargaDescargaTypes } from './types';
import { Reducer } from 'redux';

const INITIAL_STATE: CargaDescargaState = {
  data: [],
  dataTotal: {
    descarga: 0,
    centroDistribuicao: '',
    descargaConcluida: 0,
    cargas: 0,
    codemp: 0,
    cargasConcluida: 0,
    cargaPerc: 0,
    descargaPerc: 0,
    pesoCargas: 0,
    pesoDescargas: 0,
  },
  error: false,
  loading: false,
};

const reducer: Reducer<CargaDescargaState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CargaDescargaTypes.LOAD_REQUEST_CARGA_DESCARGA:
      return {
        ...state,
        loading: true,
      };

    case CargaDescargaTypes.LOAD_SUCCESS_CARGA_DESCARGA:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        dataTotal: action.payload.dataTotal,
      };

    case CargaDescargaTypes.LOAD_FAILURE_CARGA_DESCARGA:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
        dataTotal: {
          descarga: 0,
          centroDistribuicao: '',
          descargaConcluida: 0,
          cargas: 0,
          codemp: 0,
          cargasConcluida: 0,
          cargaPerc: 0,
          descargaPerc: 0,
          pesoCargas: 0,
          pesoDescargas: 0,
        },
      };

    case CargaDescargaTypes.CLEAN_CARGA_DESCARGA:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default reducer;
